import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Heart, MessageSquare, Share2, Send } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { useApp } from '../store';
export function PostPage() {
  const {
    id
  } = useParams();
  const {
    posts,
    addComment,
    requireIdentity,
    user
  } = useApp();
  const post = posts.find(p => p.id === id);
  const [liked, setLiked] = useState(false);
  const [draft, setDraft] = useState('');
  if (!post) {
    return <div className="text-center py-20" data-id="element-568">
        <p className="text-navy-500 mb-4" data-id="element-569">That post couldn't be found.</p>
        <Link to="/feed" className="text-gold-600 font-semibold" data-id="element-570">
          Back to Feed
        </Link>
      </div>;
  }
  const comments = post.comments;
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!draft.trim()) return;
    // Keep the draft if the visitor still needs to introduce themselves.
    if (!requireIdentity()) return;
    addComment(post.id, draft.trim());
    setDraft('');
  };
  return <div className="max-w-2xl mx-auto" data-id="element-571">
      <PageHeader title="" backTo="/feed" backLabel="Back to Feed" data-id="element-572" />

      <article className="bg-white rounded-xl border border-navy-100 overflow-hidden" data-id="element-573">
        <div className="p-5" data-id="element-574">
          <div className="flex items-center gap-3 mb-4" data-id="element-575">
            <img src={post.avatar} alt={post.author} className="w-12 h-12 rounded-full object-cover" data-id="element-576" />
            <div data-id="element-577">
              <p className="text-sm font-bold text-navy-900" data-id="element-578">{post.author}</p>
              <p className="text-xs text-navy-400" data-id="element-579">
                {post.role} · {post.time}
              </p>
            </div>
            <span className="ml-auto text-[0.65rem] font-semibold uppercase tracking-wide text-navy-600 bg-navy-50 px-2 py-1 rounded-full" data-id="element-580">
              {post.team}
            </span>
          </div>
          <p className="text-navy-800 leading-relaxed" data-id="element-581">{post.body}</p>
        </div>
        {post.image && <img src={post.image} alt="" className="w-full max-h-96 object-cover" data-id="element-582" />}
        <div className="flex items-center gap-1 px-5 py-3 border-t border-navy-50" data-id="element-583">
          <button onClick={() => setLiked(v => !v)} className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${liked ? 'text-gold-600' : 'text-navy-500 hover:bg-navy-50'}`} data-id="element-584">
            <Heart className={`w-4 h-4 ${liked ? 'fill-gold-500 text-gold-500' : ''}`} data-id="element-585" />{' '}
            {post.likes + (liked ? 1 : 0)}
          </button>
          <span className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-navy-500" data-id="element-586">
            <MessageSquare className="w-4 h-4" data-id="element-587" /> {comments.length}
          </span>
          <button className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-navy-500 hover:bg-navy-50 rounded-lg ml-auto" data-id="element-588">
            <Share2 className="w-4 h-4" data-id="element-589" /> Share
          </button>
        </div>
      </article>

      {/* Comments */}
      <section className="mt-6" aria-label="Comments" data-id="element-590">
        <h2 className="text-base font-serif font-bold text-navy-900 mb-4" data-id="element-591">
          {comments.length} {comments.length === 1 ? 'Comment' : 'Comments'}
        </h2>

        <form onSubmit={submit} className="flex items-center gap-3 mb-6" data-id="element-592">
          <img src={user.avatar} alt="" className="w-9 h-9 rounded-full" data-id="element-593" />
          <input value={draft} onChange={e => setDraft(e.target.value)} placeholder="Write a comment…" className="flex-1 bg-white border border-navy-100 rounded-full px-4 py-2.5 text-sm text-navy-900 placeholder:text-navy-400 focus:outline-none focus:ring-2 focus:ring-gold-400/40" data-id="element-594" />
          <button type="submit" className="p-2.5 bg-gold-500 text-navy-900 rounded-full hover:bg-gold-400 transition-colors" aria-label="Post comment" data-id="element-595">
            <Send className="w-4 h-4" data-id="element-596" />
          </button>
        </form>

        <ul className="space-y-4" data-id="element-597">
          {comments.map(c => <li key={c.id} className="flex gap-3" data-id="element-598">
              <img src={c.avatar} alt="" className="w-9 h-9 rounded-full" data-id="element-599" />
              <div className="bg-white border border-navy-100 rounded-2xl rounded-tl-sm px-4 py-2.5 flex-1" data-id="element-600">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-601">
                  <span className="text-sm font-bold text-navy-900" data-id="element-602">
                    {c.author}
                  </span>
                  <span className="text-xs text-navy-400" data-id="element-603">{c.time}</span>
                </div>
                <p className="text-sm text-navy-700" data-id="element-604">{c.body}</p>
              </div>
            </li>)}
        </ul>
      </section>
    </div>;
}